const API_ROOT = '/api/engagements'

export const getMeetingsUrl = () => `${API_ROOT}/meetings`

